export default "__VITE_ASSET__j9ZERzuY__"